export function scrollElementIntoView(
	el: HTMLElement | null,
	area: ScrollLogicalPosition = 'center',
): void {
	if (!el) {
		return;
	}

	try {
		el.scrollIntoView({ behavior: 'smooth', block: area });
	} catch (e) {
		el.scrollIntoView(false);
	}
}

export const $ = (selector: string): HTMLElement | null => document.querySelector(selector);

export const $$ = (selector: string): Array<HTMLElement> =>
	Array.from(document.querySelectorAll(selector));
